import { render, staticRenderFns } from "./SearchProducts.vue?vue&type=template&id=458419e0&scoped=true&"
import script from "./SearchProducts.vue?vue&type=script&lang=js&"
export * from "./SearchProducts.vue?vue&type=script&lang=js&"
import style0 from "./SearchProducts.vue?vue&type=style&index=0&id=458419e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458419e0",
  null
  
)

export default component.exports